// import { walkTree } from "@/utils";
import dayjs from 'dayjs'
import request from '@/request'
import store2 from '@/store2'

const state = {
	// 列表-用户搜索的参数
	ksk6p8gl_search_condition: {
		type: 'root',
		operate_options: ['and', 'or'],
		operate: 'and',
		children: [
		]
	},
	// 列表-其他搜索参数和搜索结果
	kslhow0s_search_list: {
		qs: {
			page: 1,
			pagesize: 10,
			listtp: 0,
		},
		result: {
			count: {},
			total: 0,
			wp_thead: [],
			wp_tbody: [],
		}
	},
	kstpyoet_chart_condition: [],
	ksv4vnl8_result_active_index: 0,
	// 可视化-数据
	ksvdfgih_search_chart: {},
	// 可视化-中国地图-数据
	ktwc1c5g_search_map_data: {
		data: [],
	},
	// 列表隐藏的字段
	lists_hide_field: {
		research_center: [],
		researcher: [],
		experiment: [],
		chictr: [],
		sponsor: [],
		cro: [],
		lab: [],
		smo: [],
		supplier: [],
		medicalguide: [],
		guideprinciple: [],
		linchuangus: [],
		linchuangkr: [],
        linchuangjp: [],
        researcher_risk: [],
        linchuangau: [],
	},
	// 列表的字段排序
	lists_sort_field: {
		research_center: [],
		researcher: [],
		experiment: [],
		chictr: [],
		sponsor: [],
		cro: [],
		lab: [],
		smo: [],
		supplier: [],
		medicalguide: [],
		guideprinciple: [],
		linchuangus: [],
		linchuangkr: [],
        linchuangjp: [],
        researcher_risk: [],
        linchuangau: [],
	},
	// 不请求列表可视化和地图的模块的dbid
    nochart: [5, 8, 9, 10, 14, 16],
    nomap: [5, 8, 9, 10, 11, 12, 13, 14, 15, 16],
}
const getters = {
	// 转换所有参数为后端需要格式
	ksk6p8gl_search_condition_transform(state) {
		let l = {}; let v = {};
		return state.ksk6p8gl_search_condition.children.reduce((sum, item) => {
			let val = [];
			let label = [];
			switch (item.type) {
				case 'field_blur':
					val = item.children[0].value;
					break;
				case 'field':
					{
						val = item.children.map(i => {
							return i.value;
						});
						// 把有条件的生成label参数，供后端使用
						item.children.forEach((i, k) => {
							let kk = i.label;
							let vv = i.value;
							if (kk != vv) {
								label[k] = {label:kk,value:vv}
							}
						});
					}
					break;
				case 'field_date':
					{
						let start_value = item.children[0].start_value;

						let end_value = item.children[0].end_value;

						if (start_value) {
							start_value = dayjs(
								start_value
							).format("YYYY-MM-DD")
						}
						if (end_value) {
							end_value = dayjs(
								end_value
							).format("YYYY-MM-DD")
						}

						val = `${start_value || ''}:${end_value || ''}`;
						let start_label = '';
						let end_label = '';
						if (start_value) {
							start_label = '开始 ' + start_value;
						}
						if (end_value) {
							end_label = ' 结束 ' + end_value;
						}
						label[0] = { label: start_label + end_label, value: val };
					}
			}
			if (label.length) {
				l[item.key] = label;
			}
			v[item.key] = val;
			sum = {qq: v, label: l};
			return sum;
		}, {});
	},
	// 图表-数组
	ksvdfgih_search_chart_array(state) {
		return Object.keys(state.ksvdfgih_search_chart).map(type => {
			return {
				...state.ksvdfgih_search_chart[type],
				type,
			}
		})
	},
	// 图表-中国地图-数据
	ktwc1c5g_search_map_data_transform(state) {
		// 排序后的各省市区的数组
		const data = state.ktwc1c5g_search_map_data.data.map(
			(item) => {
				return {
					name: item.label,
					value: item.value,
				};
			}
		).sort((a, b) => {
			return a.value - b.value;
		});
		return {
			data,
			max_value: data.slice(-1)[0]?.value || 0,
			min_value: data.slice(0, 1)[0]?.value || 0,
		}
	}
}
const mutations = {
	// 搜索条件提交
	ksk6p8gl_search_condition(state, payload) {
		state.ksk6p8gl_search_condition = payload;
	},
	// 结构结果提交
	kslhow0s_search_list(state, payload) {
		state.kslhow0s_search_list = payload
	},
	kstpyoet_chart_condition(state, payload) {
		state.kstpyoet_chart_condition = payload
	},
	// 搜索结果默认激活的索引
	ksv4vnl8_result_active_index(state, payload) {
		state.ksv4vnl8_result_active_index = payload
	},
	ksvdfgih_search_chart(state, payload) {
		state.ksvdfgih_search_chart = payload
	},
	ktwc1c5g_search_map_data(state, payload) {
		state.ktwc1c5g_search_map_data = payload
	},
	lists_hide_field(state, payload) {
		state.lists_hide_field = payload
	},
}
const actions = {
	// 搜索接口
	async kslhow0s_search_list({ commit, state, getters }, { dbid } = {}) {
		store2.views.search.MainView.state.isLoading = true;
		let tmpdbid = dbid ?? getters.kstq7ueu_dbid;
		if (!tmpdbid) {
			return;
		}
		let url = '/search/getLists';
		if (tmpdbid == 8 || tmpdbid == 10 || tmpdbid == 14 || tmpdbid == 16) {
			url = '/search/showLists'
		}
		let res = await request.post(url, {
			...state.kslhow0s_search_list.qs,
			dbid: dbid??getters.kstq7ueu_dbid,
			qq: getters.ksk6p8gl_search_condition_transform.qq ?? {},
			label: getters.ksk6p8gl_search_condition_transform.label ?? {},
		});
		store2.views.search.MainView.state.isLoading = false;
		if (res.state == 0) {
			commit('kslhow0s_search_list', {
				...state.kslhow0s_search_list,
				result: res.data
			});
		} else {
			return res;
		}
		// 浏览器 前进/后退：查询条件本地化
		let sessionKey = window.history?.state?.key;
		let num = 10;
		let tmp = sessionStorage.getItem('max') ?? '[]';
		let max = JSON.parse(tmp);
		if (state.ksk6p8gl_search_condition?.children.length > 0 || state.kslhow0s_search_list?.qs.page != 1 || state.kslhow0s_search_list?.qs?.listtp > 0) {
			// 有条件时，本地同步更新
			let sessionVal = JSON.stringify({ qq: state.ksk6p8gl_search_condition, qs: state.kslhow0s_search_list.qs });
			sessionStorage.setItem(sessionKey, sessionVal);
			// 处理sessionStorage容量：最多存储10条
			if (!max.includes(sessionKey + '')){
				max.unshift(sessionKey + '');
				// 删除超过10条的
				if (max.length > num) {
					let del = max.slice(num);
					del.forEach(v => {
						sessionStorage.removeItem(v);
					});
				}
				// 存储最新10条
				let save = max.slice(0, num);
				sessionStorage.setItem('max', JSON.stringify(save));
			}
		} else {
			// 删除条件时本地同步移除
			if (sessionStorage.getItem(sessionKey)) {
				sessionStorage.removeItem(sessionKey);
				let newmax = max.filter((v) => { return v != sessionKey });
				sessionStorage.setItem('max', JSON.stringify(newmax));
			}
		}
	},
	// 可视化-条件选择数据
	async kstpyoet_chart_condition({ commit, state, getters }, { dbid } = {}) {
		let id = dbid ?? getters.kstq7ueu_dbid;
		// 以下模块列表不请求可视化
		if (state.nochart.includes(id)) {
			return;
		}
		// store2.views.search.MainView.state.isLoading = true;

		let res = await request.get('/options/dashboards', {
			dbid: id,
		});
		// store2.views.search.MainView.state.isLoading = false;

		commit('kstpyoet_chart_condition', res.data.map(i => {
			return {
				...i,
				value: [],
			}
		}));
	},
	// 可视化-图表数据
    async ksvdfgih_search_chart({ getters, commit, state }, { dbid, type, page, pagesize, filters, selectItem,
		// new || append
		mode = 'new',
	}) {
		// store2.views.search.MainView.state.isLoading = true;

		let res = await request.post('/search/dashBoard', {
			dashtype: type,
			page,
            pagesize,
            filters,
			dbid: dbid??getters.kstq7ueu_dbid,
			qq: getters.ksk6p8gl_search_condition_transform.qq ?? {},
			label: getters.ksk6p8gl_search_condition_transform.label ?? {},
		})

		// store2.views.search.MainView.state.isLoading = false;
        // 通用的bar
        if (res.data.type == 'bar') {
            // 没有数据直接return
            if (!res.data?.lists || res.data.lists.series.length == 0) {
                return;
            }
        } else {
            // 没有数据直接return
            if (!res.data?.lists || res.data.lists.length == 0) {
				// 注释掉：因为当接口返回无数据时，图表不更新为暂无数据
                // return;
            }
            // 有数据继续操作
            res.data.lists = res.data.lists.filter(v => v.name);
            // 堆叠条形图
            // 逆序
            if (res.data.type === 'stackedBar') {
                res.data.lists = res.data.lists.reverse();
            }
        }

		// 追加-直接返回数据
		if (mode === 'append') {
			// 下一页参数传递
			state.ksvdfgih_search_chart[type].page = page;
			// 返回
			return res;
		}

		commit('ksvdfgih_search_chart', {
			...state.ksvdfgih_search_chart,
			[type]: {
				data: res.data.lists,
				chartType: res.data.type,
				page,
                pagesize,
                filters,
                selectItem,
			}
		});

		
	},
	// 可视化-中国地图-数据
	async ktwc1c5g_search_map_data({ getters, state, commit }, { dbid } = {}) {
		let id = dbid ?? getters.kstq7ueu_dbid;
		// 以下模块列表不请求地图
		if (state.nomap.includes(id)) {
			return;
		}
		// store2.views.search.MainView.state.isLoading = true;

		let res = await request.post('/search/getMap?field_id=33', {
			dbid: id,
			qq: getters.ksk6p8gl_search_condition_transform.qq ?? {},
			label: getters.ksk6p8gl_search_condition_transform.label ?? {},
		})
		// store2.views.search.MainView.state.isLoading = false;

		
		commit('ktwc1c5g_search_map_data', res);
	},
	// 列表隐藏的字段
	async lists_hide_field({ commit }, { res } = {}) {
		commit('lists_hide_field', res);
	},
}

export default {
	state,
	getters,
	mutations,
	actions
}
